import { ASSETS } from "./data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-slate-950 text-white py-16">
    <div className="neon-hairline absolute top-0 left-0 right-0" />
    <div className="max-w-4xl mx-auto px-6 text-center">
      <img src={ASSETS.logo} alt="Ashley Falls PTA" className="h-16 w-16 mx-auto" />
      <nav
        data-testid="footer-nav"
        className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs font-bold uppercase tracking-[0.2em]"
      >
        <a
          href="https://ashleyfallspta.org"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-home-link"
          className="text-slate-300 hover:text-cyan-300 transition-colors"
        >
          Home
        </a>
        <a
          href="https://www.ashleyfallspta.com/our_pta"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-our-pta-link"
          className="text-slate-300 hover:text-pink-400 transition-colors"
        >
          Our PTA
        </a>
        <a
          href="https://survey.ashleyfallspta.org"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-volunteer-link"
          className="text-slate-300 hover:text-yellow-300 transition-colors"
        >
          Volunteer
        </a>
        <a
          href="https://www.ashleyfallspta.com/sponsors"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-sponsors-link"
          className="text-slate-300 hover:text-fuchsia-400 transition-colors"
        >
          Our Sponsors
        </a>
      </nav>
      <p className="mt-6 font-black uppercase tracking-widest text-sm text-cyan-300">
        Ashley Falls PTA · San Diego, CA
      </p>
      <p data-testid="footer-tax-info" className="mt-4 text-sm text-slate-300 font-medium">
        Tax Deductible: Tax ID 33-0822293.{" "}
        <a
          href="https://www.ashleyfallspta.com/packet/6563"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-corporate-matching-link"
          className="text-yellow-300 font-bold underline decoration-yellow-300/60 decoration-2 underline-offset-4 hover:text-yellow-200 transition-colors"
        >
          Corporate Matching Available!
        </a>
      </p>
      <p data-testid="footer-assistance-note" className="mt-2 text-sm text-slate-400 italic">
        If financial assistance is needed, please contact the school front office.
      </p>
      <div className="mt-8 mx-auto w-24 h-[2px] bg-gradient-to-r from-pink-500 via-cyan-400 to-yellow-300 rounded-full" />
    </div>
  </footer>
);
